export const STEP_ONE_URL = "";
export const FAQ_DETAIL_URL = "";
export const FAQ_SHOW_ALL_URL = "/help/json/faqQuestions.json";
export const STEP_TWO_URL = "/help/json/stepTwo.json";
export const STEP_THREE_URL = "/help/json/stepThree.json";
// export const SEARCH_URL = "http://192.168.10.70:8081/api/search";
export const SEARCH_URL = "https://mapsa.ir/api/search";